import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { AutoTradeCoinConfigService } from '../../../_services/autotradecoinconfig.service';
import { CoinTradeModel } from '../../../_models/coin-trade';

@Component({
    selector: 'app-auto-trade-edit-coin',
    templateUrl: './auto-trade-edit-coin.component.html',
    styleUrls: ['./auto-trade-edit-coin.component.css']
})
export class AutoTradeEditCoinComponent extends DialogComponent<CoinTradeModel, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string = '';
    messages: any[] = [];
    returnUrl: string;
    pairs: any[] = [];
    pairName: any[] = [];
    pair: number = 1;
    amount: number;
    stopLoss: number;
    coinId: string;
    coinName: string;
    focusEventEmitter = new EventEmitter<boolean>();

    constructor(
        dialogService: DialogService,
        private autoTradeCoinConfigService: AutoTradeCoinConfigService
    ) {
        super(dialogService);
    }

    ngOnInit() {
        this.pairs.forEach(element => {
            this.pairName[element.id] = element.name;
        });
        this.loading = true;
        this.model.amount = this.amount;
        this.model.stopLoss = this.stopLoss;
        this.loading = false;
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    edit() {
        this.loading = true;
        this.message = '';
        this.model.id = this.coinId;
        this.autoTradeCoinConfigService.edit(this.model).subscribe(data => {
            if (data.error) {
                this.messages = data.message;
            }
            else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }

}




// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/auto-trade-coin-config/auto-trade-edit-coin/auto-trade-edit-coin.component.ts